var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47401 8.5299C5.73436 8.79025 5.73436 9.21236 5.47401 9.47271C5.21366 9.73306 4.79155 9.73306 4.5312 9.47271L0.531201 5.47271C0.278815 5.22032 0.269984 4.81393 0.511169 4.55082L4.17784 0.55082C4.42663 0.279407 4.84834 0.261071 5.11976 0.509866C5.39117 0.758661 5.4095 1.18037 5.16071 1.45178L1.92536 4.98125L5.47401 8.5299Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.629e92db34586e0195ed0bd2f1897e15.svg";
export { ForwardRef as ReactComponent };